<template>
  <div class="container">
    <div class="card" v-if="punctualArriveInfo.description">
    {{ punctualArriveInfo.description }}
  </div>
  <div class="card" v-if="punctualArriveInfo.supplier_id">
    <div class="fw-bold">{{punctualArriveInfo.supplier_name}}</div>
    <div class="fw-bold border-bottom mt10" style="font-size: .56rem;padding-bottom: .24rem;">{{punctualArriveInfo.guaranteeStatusStr}}</div>
    <div class="flex-row-bc mt24">
      <div style="width: 70%;">
        <div>{{punctualArriveInfo.orderStatusTitle}}</div>
        <div class="mt10">{{punctualArriveInfo.guaranteeDetailDesc}}</div>
      </div>
      <a class="btn-plain btn-yellow btn-kf" v-if="punctualArriveInfo.headOfficeTel" :href="'tel:'+ punctualArriveInfo.headOfficeTel">联系客服</a>
    </div>
  </div>
  <div class="fs-32 fw-bold">{{punctualArriveInfo.content}}</div>
  <div class="card">
    <div class="flex-row-bc mb24" v-for="(item,index) in punctualArriveInfo.contentList" :key="index">
      <div class="fw-bold">{{item.contentKey}}</div>
      <div class="fc-666">{{item.contentValue}}</div>
    </div>
    <div class="rule-list">
      <div class="item" v-for="(item,index) in punctualArriveInfo.ruleList" :key="index">
        <div>{{item.overTimeDesc}}</div>
        <div>{{item.compensateDesc}}</div>
      </div>
    </div>
    <div class="rule-tips" @click="viewRules()">
      <div v-html="punctualArriveInfo.ruleTips"></div>
    </div>
  </div>
  </div>
</template>

<script>
  import { actions } from '../store/actions'
  export default {
    data () {
      return {
        punctualArriveInfo: {}
      }
    },
    created () {
      if (localStorage.getItem('orderPreviewInfo')) {
        let orderPreviewInfo = JSON.parse(localStorage.getItem('orderPreviewInfo'));
        if(orderPreviewInfo.punctualArrive && orderPreviewInfo.punctualArrive.jumpParam){
          let punctualArriveInfo = JSON.parse(orderPreviewInfo.punctualArrive.jumpParam);
          this.handleData(punctualArriveInfo.value);
          if (punctualArriveInfo.title) {
            document.title = punctualArriveInfo.title;
          }
        }
      }
      if(this.$route.query.orderId){
        let _this = this;
        actions.getPunctualOrderDetail(_this, { order_id: this.$route.query.orderId}, (res) => {
          this.handleData(res);
        })
      }
    },
    methods: {
      handleData(data) {
        if(data.spanList){
          let spanList = data.spanList;
          if(data.ruleTips){
            let ruleTips = data.ruleTips;
            spanList.forEach((item)=>{
              if(ruleTips.indexOf(item.title) > -1){
                data.ruleTips = ruleTips.replace(item.title,`<span style="color: ${item.titleColor}">${item.title}</span>`)
                data.ruleTipsJump = JSON.parse(item.jumpParam);
              }
            })
          }
        }
        this.punctualArriveInfo = data;
      },

      viewRules() {
        if(this.punctualArriveInfo.ruleTipsJump && this.punctualArriveInfo.ruleTipsJump.url){
          location.href = this.punctualArriveInfo.ruleTipsJump.url;
        }
      },
    }

  }
</script>
<style scoped>
.container{
  padding: .24rem;
}
.card{
  padding: .24rem;
  background: #FFFFFF;
  border-radius: .16rem;
  font-size: .28rem;
}
.rule-list{
  border-radius: .16rem;
  border: .02rem solid #EFEFEF;
  margin-bottom: .24rem;
}
.rule-list .item{
  display: flex;
  align-items: center;
  height: 1rem;
  line-height: 1rem;
}
.rule-list .item >div{
  flex: 1;
  text-align: center;
  border-bottom: .02rem solid #EFEFEF;
  border-right: .02rem solid #EFEFEF;
}
.rule-list .item:first-child div{
  font-weight: bold;
}
.rule-list .item:last-child div{
  border-bottom: none;
}
.rule-list .item div:last-child{
  border-right: none;
}
.rule-tips{
  font-size: .2rem;
  color: #999;
}
.ptb24{
  padding: .24rem 0;
}
.mb24{
  margin-bottom: .24rem;
}
.mt24{
  margin-top: .24rem;
}
.btn-kf{
  display: block;
  font-size: .28rem;
  border: none;
}
</style>



// WEBPACK FOOTER //
// PunctualArrive.vue?31996156